<template>
  <div class='flex flex-col'>
    <input v-model="search" @input="fetchConsults" style="width: 100%" class="p-2 relative bg-white rounded-sm border border-solid border-grey-lightest 
    text-base text-grey-darkest focus:border-blue" type="search" placeholder="Search by name, email...">
    <div class="flex flex-row h-1 bg-grey-lightest flex-no-shrink flex-no-grow" />
    <div v-if="consultations.length === 0">
      <span class="text-sm flex justify-center my-4">No Consultations</span>
    </div>
    <div v-else class='flex flex-col overflow-y-auto pb-4' style="height: calc(100vh - 8.5rem);">
      <div v-for="(cp, index) in consultations" :key="index" @click="selectFromPastList(cp.consultation.consultationId, cp.consultationRequest.consultationRequestId)" 
        v-bind:class="(cp.consultationRequest.consultationRequestId === activePastConsultationRequestId) ? 'bg-grey-extralight' : ''" 
        class="flex flex-col h-16 pl-3 flex-no-shrink flex-no-grow justify-center hover:bg-grey-extralight cursor-pointer">
        <div class="flex flex-row pt-2">
            <div class="text-sm font-semibold self-center capitalize">{{cp.name ? cp.name: cp.customerId}}</div>
            <!-- <div class="text-xs ml-2 bg-blue  rounded-full px-3 text-white self-center leading-normal">FQ</div> -->
        </div>
        <div class="flex flex-row py-2 pr-2">
          <div v-if="consultStatus(cp)" class="text-xs text-green-light font-light">Case Closed</div>
          <div v-else class="text-xs text-red-light font-light">Summary Pending</div>
          <div class="text-xs ml-auto text-grey-dark font-light">{{cp.consultationRequest.date | formatDate}}</div>
        </div>
      </div>
      <div v-if="showLoadMore" class="flex flex-col h-12 justify-center">
        <div @click="fetchMoreConsults" class="flex px-3 py-2 justify-end cursor-pointer italic rounded-sm text-blue text-sm hover:text-grey-darker">
          Load more . . .
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import Vue from 'vue'
export default {
  props: ['doctor'],
  data () {
    return {
      consultations: [],
      search: '',
      page: 1
    }
  },
  created: function () {
  },
  mounted: function () {
    this.getDoctorConsults()
  },
  computed: {
    ...mapState({
      pastConsults (state) {
        this.consultations = state.pastConsultation.pastConsults
        return state.pastConsultation.pastConsults
      },
      activePastConsultationRequestId: state => state.pastConsultation.activePastConsultationRequestId
    }),
    ...mapGetters({
      showLoadMore: 'pastConsultation/showLoadMore'
    })
  },
  watch: {
    pastConsults: function (value) {
      this.consultations = value
    }
  },
  methods: {
    selectFromPastList: function (id, consultationRequestId) {
      this.$store.dispatch('pastConsultation/switchTo', {id: id, consultationRequestId: consultationRequestId})
    },
    consultStatus: function (cp) {
      if (cp.consultation.summary_status === 'done' || cp.consultation.summary_status === 'not_needed') {
        return true
      } else {
        return false
      }
    },
    getDoctorConsults: function () {
      this.selectedDoctor = this.doctor.id
      this.isLoading = true
      let that = this
      if (this.doctor.doctor_id === null) {
      } else {
        this.getDoctorConsultsApi().then(response => {
          if (response.status === 200) {
            that.$store.dispatch('pastConsultation/setUpPastConsults', {details: response.body.consultations, total: response.body.total})
          } else {
          }
        }, response => {
        })
      }
    },
    fetchConsults: function () {
      let that = this
      if (this.search !== '' && this.doctor.doctor_id) {
        this.getDoctorConsultsApi().then(response => {
          if (response.status === 200) {
            that.$store.dispatch('pastConsultation/setUpPastConsults', {details: response.body.consultations, total: response.body.total})
          } else {
          }
        }, response => {
        })
      }
    },
    fetchMoreConsults: function () {
      let that = this
      this.page = this.page + 1
      this.getDoctorConsultsApi().then(response => {
        if (response.status === 200) {
          that.$store.dispatch('pastConsultation/loadMoreConsultsAdmin', {pastConsults: response.body.consultations})
        }
      })
    },

    getDoctorConsultsApi () {
      let query = 'page=' + this.page + '&type=text&doctor_id=' + this.doctor.doctor_id
      if (this.search && this.search !== '') query = query + '&term=' + this.search
      return Vue.http.get(window.API_URL + 'doctors/doctor_consults?' + query)
    }
  }
}
</script>

<style>
.patientActive {
  background-color: #dae1e7
}

</style>


// WEBPACK FOOTER //
// src/components/Admin/DoctorConsultations.vue